module.exports = __webpack_public_path__ + "img/check-3.1cae392e.svg";